@if (control) {
  <mat-form-field
    appearance="outline"
    class="ui-select-field ui-form-field-v2"
    [subscriptSizing]="description ? 'dynamic' : 'fixed'"
  >
    <mat-label>{{ label }}</mat-label>
    <mat-select
      panelClass="app-ui-select"
      [hideSingleSelectionIndicator]="true"
      [formControl]="control"
      [multiple]="isMultiple"
      (selectionChange)="onChange($event)"
      (openedChange)="onPanelOpenedChange($event)"
      [value]="selected"
      [required]="required"
      [errorStateMatcher]="errorStateMatcher"
      [compareWith]="compareWith"
    >
      <mat-select-trigger>
        @if (!isMultiple && control.value !== null && control.value !== undefined) {
          <span class="ui-select-trigger-content">
            <span class="ui-select-trigger-label">
              {{ getSelectedOptionName(control.value) }}
            </span>
            @if (isSelectedOptionPaused(control.value)) {
              <app-department-paused-badge
                class="ui-select-trigger-paused-badge"
                [iconOnly]="true"
              ></app-department-paused-badge>
            }
          </span>
        }
        @if (isMultiple && control.value?.length > 0) {
          <span>{{ getMultipleSelectedOptionNames(control.value) }}</span>
        }
      </mat-select-trigger>
      @if (enableSearch) {
        <input
          #searchInput
          (keyup)="$event.stopPropagation(); onSearch($event)"
          (keydown)="$event.stopPropagation()"
          (keydown.space)="$event.preventDefault(); $event.stopPropagation()"
          placeholder="{{ 'search' | translate }}"
          class="mat-dropdown-select-input"
        />
      }
      @if (selectAll) {
        <mat-optgroup class="select-all-checkbox-row-group divider-bottom">
          <mat-checkbox
            class="mat-option select-all-row"
            color="primary"
            [ngClass]="{ 'mat-selected': areSomeRowsSelected || areAllRowsSelected }"
            [indeterminate]="areSomeRowsSelected"
            [checked]="areAllRowsSelected"
            (click)="$event.stopPropagation()"
            (change)="toggleSelection($event)"
          >
            {{ 'selectAll' | translate }}
          </mat-checkbox>
        </mat-optgroup>
      }
      @for (group of displayedOptionGroups; track $index) {
        <mat-optgroup [label]="group.type | translate">
          <ng-container
            *ngTemplateOutlet="optionsTemplate; context: { $implicit: group }"
          ></ng-container>
        </mat-optgroup>
      }
      <ng-template #optionsTemplate let-group>
        @for (option of group.options; track option.id) {
          @if (returnWholeObject) {
            <mat-option [value]="{ value: option, type: group.type }">
              {{ option.name }}
            </mat-option>
          } @else {
            <mat-option [value]="option.id">
              <div class="ui-select-option-row">
                <span class="ui-select-option-label">{{ option.name }}</span>
                @if (option.isPaused) {
                  <app-department-paused-badge
                    class="ui-select-paused-badge"
                    [iconOnly]="true"
                  ></app-department-paused-badge>
                }
              </div>
            </mat-option>
          }
        }
      </ng-template>
    </mat-select>
    @if (description) {
      <mat-hint>{{ description }}</mat-hint>
    }
    @let errorText = control.errors | joinErrorMessages: messages;
    <mat-error [attr.title]="errorText">{{ errorText }}</mat-error>
  </mat-form-field>
}
